import React from 'react';
import { MailIcon, MapPinIcon, MessageSquareIcon, PhoneIcon, InstagramIcon, FacebookIcon } from 'lucide-react';
import { CONTACT } from '../data/site';
const NAV = [{
  label: 'Home',
  href: '#home'
}, {
  label: 'Coach Leonard',
  href: '#coach'
}, {
  label: 'Programs',
  href: '#programs'
}, {
  label: 'Gallery',
  href: '#gallery'
}, {
  label: 'FAQ',
  href: '#faq'
}, {
  label: 'Register',
  href: '#register'
}];
export function Footer() {
  return <footer className="w-full border-t border-ink-line bg-ink-soft pb-28 pt-14 sm:pb-16" data-id="element-52" data-mp="3ucxmluzhkx9s">
      <div className="mx-auto max-w-7xl px-4 sm:px-6" data-id="element-53" data-mp="37xuse6oxwgy">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-54" data-mp="3lf56iolxxllc">
          <div data-id="element-55" data-mp="3qdf2h1fhoq80">
            <div className="flex items-center gap-3" data-id="element-56" data-mp="3qcxaigzv0y5w">
              <img src={CONTACT.logo} alt="Leal 11 Sports logo" className="h-12 w-12 rounded-full object-cover ring-1 ring-white/20" data-id="element-57" data-mp="3qblzbw434o4r" />
              <span className="font-display text-xl uppercase" data-id="element-58" data-mp="2ezl4q0kji5h3">Leal 11 Sports</span>
            </div>
            <p className="mt-4 max-w-xs text-sm text-white/60" data-id="element-59" data-mp="3l9sgay2igglb">
              Elite youth soccer training in Queens, NYC. Led by FIFA Registered Coach Leonard Leal.
            </p>
            <div className="mt-6 flex items-center gap-4" data-id="element-60" data-mp="3v9b0nfmc24dw">
              <a href={CONTACT.instagram} target="_blank" rel="noreferrer" className="text-white/40 transition-colors hover:text-brand-orange" aria-label="Instagram" data-id="element-61" data-mp="3q83tnis0l98a">
                <InstagramIcon className="h-5 w-5" data-id="element-62" data-mp="31uotg9z09ou" />
              </a>
              <a href={CONTACT.facebook} target="_blank" rel="noreferrer" className="text-white/40 transition-colors hover:text-brand-orange" aria-label="Facebook" data-id="element-63" data-mp="hrihxu80021h">
                <FacebookIcon className="h-5 w-5" data-id="element-64" data-mp="ms6d8s39f51i" />
              </a>
            </div>
          </div>

          <nav aria-label="Footer" data-id="element-65" data-mp="tvmqbhqesglw">
            <h2 className="font-display text-sm uppercase tracking-[0.18em] text-white/80" data-id="element-66" data-mp="two2xqn2pb5q">
              Explore
            </h2>
            <ul className="mt-4 space-y-2 text-sm" data-id="element-67" data-mp="yrv00flu7hlo">
              {NAV.map(link => <li key={link.href} data-id="element-68" data-mp="13r7m2y4vwkn7">
                  <a href={link.href} className="text-white/60 transition-colors hover:text-brand-orange" data-id="element-69" data-mp="18kix7bgqbnkx">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-70" data-mp="1mk1sh3ofz4ft">
            <h2 className="font-display text-sm uppercase tracking-[0.18em] text-white/80" data-id="element-71" data-mp="1mjil2gwf3yg1">
              Contact
            </h2>
            <ul className="mt-4 space-y-3 text-sm text-white/60" data-id="element-72" data-mp="1rid2beeqley1">
              <li data-id="element-73" data-mp="3obx0987kuosr">
                <a href={`tel:+1${CONTACT.phoneRaw}`} className="inline-flex items-center gap-2 transition-colors hover:text-brand-orange" data-id="element-74" data-mp="3ocgiyr51xh7u">
                  <PhoneIcon className="h-4 w-4 text-brand-orange" aria-hidden="true" data-id="element-75" data-mp="2ag5dkmdud4ej" />
                  {CONTACT.phoneDisplay}
                </a>
              </li>
              <li data-id="element-76" data-mp="21mk0r8l8lx7r">
                <a href={CONTACT.sms} className="inline-flex items-center gap-2 transition-colors hover:text-brand-orange" data-id="element-77" data-mp="21m0jlu3evcus">
                  <MessageSquareIcon className="h-4 w-4 text-brand-orange" aria-hidden="true" data-id="element-78" data-mp="2tdpun7ad6yol" />
                  Text us: {CONTACT.phoneDisplay}
                </a>
              </li>
              <li data-id="element-79" data-mp="2pajsaaqdhrne">
                <a href={`mailto:${CONTACT.email}`} className="inline-flex items-center gap-2 transition-colors hover:text-brand-orange" data-id="element-80" data-mp="2kd1hsfwpj4da">
                  <MailIcon className="h-4 w-4 text-brand-orange" aria-hidden="true" data-id="element-81" data-mp="18xuwx1ssrdsb" />
                  {CONTACT.email}
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-82" data-mp="2rvr7dezagofc">
            <h2 className="font-display text-sm uppercase tracking-[0.18em] text-white/80" data-id="element-83" data-mp="2rv7p1x5q7y0s">
              Training location
            </h2>
            <p className="mt-4 inline-flex items-start gap-2 text-sm text-white/60" data-id="element-84" data-mp="2wo0ukn90radx">
              <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-orange" aria-hidden="true" data-id="element-85" data-mp="2iw48p0xy1wpz" />
              <span data-id="element-86" data-mp="2nuxkmoxl1fo1">
                Juniper Valley Park
                <br data-id="element-87" data-mp="3bjzz5nwx6seb" />
                {CONTACT.location}
              </span>
            </p>
            <a href="#register" className="mt-5 inline-flex rounded-full bg-gradient-to-r from-brand-orange to-brand-red px-5 py-2.5 text-xs font-bold uppercase tracking-wide text-white" data-id="element-88" data-mp="3flbr4039nppo">
              Claim 20% Off
            </a>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-2 border-t border-ink-line pt-6 text-xs text-white/40 sm:flex-row sm:items-center sm:justify-between" data-id="element-89" data-mp="1q6dpidhgg4n0">
          <p data-id="element-90" data-mp="1v69x0mpd2e7b">© {new Date().getFullYear()} Leal 11 Sports. All rights reserved.</p>
          <p data-id="element-91" data-mp="1nkwiy9b4tcgx">Middle Village · Maspeth · Ridgewood · Forest Hills</p>
        </div>
      </div>
    </footer>;
}